import { Component, OnInit } from '@angular/core';
import {GlobalDataService, ResetAuthToken} from '../global-data.service';
import {Router} from '@angular/router';
import {AuthenticationService} from '../authentication-service.service';
import {ViewCustomersService} from '../view-customers.service';

@Component({
  selector: 'app-view-customers',
  templateUrl: './view-customers.component.html',
  styleUrls: ['./view-customers.component.css'],
  providers: [ViewCustomersService]
})
export class ViewCustomersComponent implements OnInit {

  private gridData: any;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: ViewCustomersService) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    this.componentService.getData().then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.gridData = result;
  }

  mainFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
  }

  editHandler(event) {
    this.router.navigate(['/manage/customer'], { queryParams: { id: event.dataItem.id } });
    console.log(event.dataItem);
  }

}



// WEBPACK FOOTER //
// ./src/app/view-customers/view-customers.component.ts